import { put, call } from "redux-saga/effects";
import { donationConstants } from '../actions/constants/donationConstants';
import DonationService from "../services/api/donationService";

function* donationGetByFilter(request) {
	try {
		const result = yield call(DonationService.donationGetByFilter, request.input);
		if (result.data.isSuccess) {
			yield put({
				type: donationConstants.DonationGetByFilterSuccess,
				payload: result.data
			});
		}
		else {
			yield put({ type: donationConstants.DonationGetByFilterFailure, payload: result.data.status });
		}
	} catch (error) {
		yield put({ type: donationConstants.DonationGetByFilterFailure, payload: error });
	}
}

function* donationRecurringGetByFilter(request) {
	try {
		const result = yield call(DonationService.donationGetByFilter, request.input);
		if (result.data.isSuccess) {
			yield put({
				type: donationConstants.DonationRecurringGetByFilterSuccess,
				payload: result.data
			});
		}
		else {
			yield put({ type: donationConstants.DonationRecurringGetByFilterFailure, payload: result.data.status });
		}
	} catch (error) {
		yield put({ type: donationConstants.DonationRecurringGetByFilterFailure, payload: error });
	}
}

export const donationSaga = {
	donationGetByFilter,
	donationRecurringGetByFilter
}